export enum SeasonRosterTableColumns {
  Status = "status",
}
